// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"a582a779","683":"a582a779"}[chunkId] + ".chunk.css";
};